export const MuiPaper = {
    styleOverrides: {
        root: ({ theme })=>({
                backgroundColor: theme.palette.background.default
            })
    }
};

//# sourceMappingURL=paper.js.map